import React from "react";
import { useController } from "react-hook-form";

const Radio = ({ checked, children, control, name, id, ...rest }) => {
	const { field } = useController({
		control,
		name,
		defaultValue: "",
	});
	return (
		<div className="pms-input-radio w-auto">
			<input
				type="radio"
				checked={checked}
				id={id}
				name={name}
				{...field}
				{...rest}
			/>
			<label htmlFor={id}>
				{children}
				{checked}
			</label>
		</div>
	);
};

export default Radio;
